import React, {useCallback, useEffect} from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import {ReactComponent as Logo} from '../../logo3.svg'
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Button from '@mui/material/Button';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import classes from './ResetPassword.module.scss'
import LoadingButton from '@mui/lab/LoadingButton';
// import userStore from '../common/userStore';
import { createApi } from '../common/API'
import userStore from '../common/userStore';
import { useLocation, useNavigate } from "@reach/router"
import Password from '../account/Password'
import useTitle from '../../hooks/title';


const inputClasses = {'root':classes.input, 'notchedOutline': classes.notchedOutline}

const verifyTicket = createApi('/user/verifyTicket', {method: 'POST', expandData: true, notify: true, noThrow: false});
const resetPassword = createApi('/user/resetPassword', {method: 'POST', expandData: true, notify: true, noThrow: false});


const SuccessResult = observer(() => {
  return <div className={classes.result}>
    <div className={classes.resultWrapper}></div>
    <div className={classes.resultContent}>
      <div className={classes.successWrap}><CheckCircleIcon  className={classes.successIcon} /></div>
      <div className={classes.successInfo}>Your password has been reset successfully</div>
    </div>
  </div>
})


const ErrorResult = observer(() => {
  return <div className={classes.result}>
    <div className={classes.resultWrapper}></div>
    <div className={classes.resultContent}>
      <div className={classes.errorWrap}><ErrorIcon className={classes.errorIcon} /></div>
      <div className={classes.errorInfo}>Access ticket expried</div>
    </div>
  </div>
})

const ResetPassword = observer(({}) => {
  const location = useLocation();
  const navigate = useNavigate()
  const query = new URLSearchParams(location.search)
  useTitle('Reset Password')

  const form = useLocalObservable(() => ({
      status: 'form', // error, success
      email: '',
      password: '',
      password2: '',
      loading: false,
      posting: false,
      errors: {password: null, password2: null, submit: null},
      immediately: false,
      async load() {
        const ticket = query.get('ticket')
        try {
          this.loading = true
          
          const rs = await verifyTicket({ticket})
          this.email = rs

        } catch (e) {
          console.error('reset fail', e)
          this.status = 'error'

          setTimeout(() => {
            navigate('/auth/login', {replace: true})
          }, 3000)

        } finally {
          this.loading = false
        }
      },
      handlePassword(e) {
        this.password = e.target.value
        this.immediately && this.validPassword()
      },
      handlePassword2(e) {
        this.password2 = e.target.value
        this.immediately && this.validPassword2()
      },
      validPassword() {
        if (this.password.length == 0) {
          this.errors.password = 'Password is required'
          return false
        }
        if (this.password.length < 8) {
          this.errors.password = 'Password must has at lease 8 characters'
          return false
        }
        this.errors.password = null
        return true
      },
      validPassword2() {
        if (this.password2.length == 0) {
          this.errors.password2 = 'Confirm password is required'
          return false
        }
        if (this.password != this.password2) {
          this.errors.password2 = 'Password and confirmation password do not match'
          return false
        }
        this.errors.password2 = null
        return true
      },
      handleKeyup(e) {
        if(e.keyCode === 13) {
          this.handleSubmit()
        }
      },
      async handleSubmit() {
        try {
          this.immediately = true
          if ([this.validPassword(), this.validPassword2()].some(r => !r)) {
            return;
          }
          this.posting = true
          const ticket = query.get('ticket')
          await resetPassword({ticket, newPassword: this.password});
          this.status = 'success'
          setTimeout(async() => {
            await userStore.logout()
            navigate('/auth/login', {replace: true})
          }, 3000)
        } catch (e) {
          console.error('reset fail', e)
          // setTimeout(() => {
          //   navigate('/login', {replace: true})
          // }, 2000)
        } finally {
          this.posting = false
        }
      }
  }))

  useEffect(() => {
    const ticket = query.get('ticket')
    if (!ticket) {
      navigate('/', {replace: true})
      return;
    }
    form.load()
  }, [form, navigate])

  const center = <div className={classes.center}>
    <div className={classes.logo}><Logo /></div>
    <h1 className={classes.title}>Reset password</h1>
    <div className={classes.tips}>Enter a new password to<br />{form.email}</div>

    <FormControl className={classes.field}>
      <Password classes={inputClasses} 
        name="password"
        size="small" 
        placeholder="New password: 8+ characters" 
        autoFocus
        onChange={form.handlePassword} 
        onKeyUp={form.handleKeyup} />
    </FormControl>
    <div className={classes.error}>{form.errors.password}</div>

    <FormControl className={classes.field}>
      <Password classes={inputClasses} 
        name="password2"
        size="small" 
        placeholder="Confirm new password" 
        onChange={form.handlePassword2} 
        onKeyUp={form.handleKeyup} />
    </FormControl>
    <div className={classes.error}>{form.errors.password2}</div>

    <LoadingButton
      className={classes.submit}
      variant="contained" 
      disableElevation 
      onClick={form.handleSubmit}
      loading={form.posting}
      disabled={form.loading}
      >Submit</LoadingButton>
  </div>

  let display = center;
  if (form.status == 'success') {
    display = <SuccessResult />
  }
  if (form.status == 'error') {
    display = <ErrorResult />
  }

  return <div className={classes.root}>
    <div className={classes.wrapper}></div>
    {display}
  </div>
})

export default ResetPassword